module.exports = __webpack_public_path__ + "img/khp-bot-300w.42c769c4.jpg";